import React from 'react';
import useScreenSize from '../../../hooks/useScreenSize';
import { NumberSelectDesktop } from './Desktop';
import { NumberSelectMobile } from './Mobile';
import { NumberSelectProps } from './types';

export type { NumberSelectProps } from './types';

export const NumberSelect: React.FC<NumberSelectProps> = props =>
  useScreenSize().isSmall ? (
    <NumberSelectMobile {...props} />
  ) : (
    <NumberSelectDesktop {...props} />
  );
